import axios from 'axios';
import { env } from '@/lib/config/env';
import { getAuthToken } from './auth';
import { useAuth } from '@/lib/store';

export const api = axios.create({
  baseURL: env.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle JWT expiration (401 Unauthorized)
    if (error.response?.status === 401) {
      // Clear token from localStorage
      localStorage.removeItem('auth_token');
      
      // Force logout using the auth store
      const logout = useAuth.getState().logout;
      logout();
      
      return Promise.reject(new Error('Session expired. Please log in again.'));
    }
    
    // Handle other authorization errors (403 Forbidden)
    if (error.response?.status === 403) {
      localStorage.removeItem('auth_token');
      const logout = useAuth.getState().logout;
      logout();
      return Promise.reject(new Error('Authorization failed'));
    }
    
    return Promise.reject(error);
  }
);